import React, {Component} from 'react';
import Modal from "react-responsive-modal";
import {connect} from 'react-redux';
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import {bindActionCreators} from 'redux';
import { withRouter } from "react-router-dom";
import {encrypt} from "../../../helpers/CryptoJs";

import { createAlbum } from "../../../actions/mediaAction";
import { loader } from '../../../actions/utils';
import './../album.css';
import AlbumImage from './AlbumImage';
import { cloudinaryAlbumUploader } from './../../../helpers/cloudinaryFileUploader';
import iconPath from "./../../../helpers/iconHelper";
import { getlanguagelist } from "../../../helpers/changelanguage";

const customStyles = {
  width: '556px',
  position: 'relative'
};

class CreateAlbum extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open        : false,
      isLoading   : false,
      post_content: '',
      media_files : [],
      raw_file    : [],
      shouldHide  : 'hidden',
      raw_file_to : [],
    };
 
    this.onSubmit     = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onOpenModal  = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.fileUpload   = this.fileUpload.bind(this);
    this.changeFile   = this.changeFile.bind(this);
    this.formSubmit   = this.formSubmit.bind(this);
    this.romoveImage  = this.romoveImage.bind(this);
    this.preview      = this.preview.bind(this);
  }

  onOpenModal() {
    this.setState({open: true});
  };

  onCloseModal() {
    this.setState({ open         : false,
                    post_content : '',
                    media_files  : [],
                    raw_file     : [],
                    shouldHide   : 'hidden',
                });
  };
 
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  romoveImage(e){
    let rawFile = this.state.raw_file;
    rawFile.splice(e, 1);

    let mediaFiles = this.state.media_files;
    mediaFiles.splice(e, 1);

    let rawFileTo = this.state.raw_file_to;
    rawFileTo.splice(e, 1);
   
    this.setState({raw_file    : rawFile,
                   media_files : mediaFiles,
                   raw_file_to : rawFileTo
                  });
  };

  changeFile(e){
    let create_preview = this.state.raw_file;
    let  languagelist = getlanguagelist();
    let total_file_arr = e.target.files;
    this.setState({raw_file_to : Array.from(e.target.files)});
   
    for (let i = 0; i < (total_file_arr.length); i++) { 
      let file = e.target.files[i];
      
      let sizeInMB = (e.target.files[i].size / (1024*1024)).toFixed(2);
      console.log(sizeInMB);

        if(file.type.includes("image")){

          if(sizeInMB > 2){
            ToastsStore.error(languagelist.validimage);
          }else{
            let reader = new FileReader();
            let url = reader.readAsDataURL(file);
            reader.onloadend = function (e) {
              create_preview.push(reader.result);
              this.setState({
                shouldHide : '',
                raw_file   : create_preview
              });
            }.bind(this);

          }
        }else{

            var video = document.createElement('video');
            video.preload = 'metadata';
            var obj = this;
            video.onloadedmetadata = function() {
              window.URL.revokeObjectURL(video.src);
              if (video.duration > 120) {
                ToastsStore.error(languagelist.validvedio);
                return;
              }
              obj.preview(file);
            }
             video.src = URL.createObjectURL(file);
          }
    }
       
  }
  preview(file){
    let create_preview = this.state.raw_file;
      let reader = new FileReader();
      let url = reader.readAsDataURL(file);
      reader.onloadend = function (e) {
        create_preview.push(reader.result);
        this.setState({
          shouldHide : '',
          raw_file   : create_preview
        });
      }.bind(this);
  }
  
  componentDidMount(){
    this.romoveImage();
  }

  onSubmit(e){
    e.preventDefault();
    if(this.state.raw_file.length > 0){
      this.fileUpload(this.state.raw_file);  
    }else{
      ToastsStore.error('select file');
    }
  };

  formSubmit(e){
   
    const isValid = true; 
    if (isValid){
      this.props.createAlbum(this.state);
    }else{
      ToastsStore.error(error.message)
      this.setState({isLoading  : false});
    } 
  }
  fileUpload(file){

    this.setState({isLoading: true});
    loader(true);
    let new_res = [];
    let uploadResponse = [];
    let uploadPathImage = `uploads/${this.props.currentUserDetails.user.id}/album_image_path`;
    let uploadPathVideo = `uploads/${this.props.currentUserDetails.user.id}/album_video_path`;
    uploadResponse = cloudinaryAlbumUploader(file,uploadPathImage,uploadPathVideo);
   
    uploadResponse.then((response)=>{
      response.map(res => {
        new_res.push({'media_type':(res.data.resource_type == 'video') ? 'VIDEO'  : 'IMAGE','media_link':`${res.data.public_id}.${res.data.format}`,'media_website':''});
      })
      this.setState({
        media_files: new_res
      });
      this.formSubmit();
    });
  } 
 
  componentDidUpdate() {
    //console.log(this.props.lastCreatedPost.post_id);
  }
  

  UNSAFE_componentWillReceiveProps(nextProps) {

    if(this.props.lastCreatedAlbum != nextProps.lastCreatedAlbum){
      ToastsStore.success('Album created successfully');
      this.setState({
        isLoading    : false,
        post_content : '',
        open         : false,
        media_files  : [],
        raw_file     : [],
        shouldHide   : 'hidden',
      })
      setTimeout(() => {
        this.onCloseModal();
        this.props.history.push(`/album/${encrypt(nextProps.lastCreatedAlbum.id)}`)
      }, 2000);
    }
   }

  render() {
    //console.log(this.state.open);
    let  languagelist = getlanguagelist();
   
    return (
      <div>
        <a href={void(0)} className="add_image_icon" onClick={this.onOpenModal}><img src={iconPath['LARGEADD']} /></a>
        <Modal open={this.state.open} onClose={this.onCloseModal} showCloseIcon={false} center>
          <form id="createpost-form" onSubmit={this.onSubmit}>
            <div className="modal-header2">
            <button type="button" className="close" onClick={this.onCloseModal} ><img src="/assets/images/close_btn.png"/></button>
              {
                  (this.props.currentUserDetails.user.image != '') ? 
                  <img className="post_user" src={this.props.currentUserDetails.user.image} onError = {(e) => {
                    e.target.src = iconPath['DEFAULTUSER'] 
                  }}/> : 
                  <img className="post_user" src={iconPath['DEFAULTUSER']}/>
              }
              
              <h4 className="modal-title">{this.props.currentUserDetails.user.full_name}</h4>
            </div>
            <div className="modal-body" style={customStyles}>
           
              {/* <textarea
                className="modal-textarea"
                placeholder={languagelist.albumtitle}
                name="post_content"
                id="post_content"
                value={this.state.post_content}
                onChange={this.handleChange}
                required
                ></textarea> */}
                <input 
                  type="text" 
                  className="modal-input" 
                  placeholder={languagelist.albumtitle}
                  name="post_content"
                  id="post_content"
                  value={this.state.post_content}
                  onChange={this.handleChange}
                  required 
                />
                <div id="imageSection"  className={this.state.shouldHide}>
                   {/*  <img src={this.state.raw_file}/> */}
                   <AlbumImage images={this.state.raw_file} romoveImage={this.romoveImage}/>
                </div>
              <ul className="attach_list">
               {/*  <li>
                  <a href="#">
                    <i className="fa fa-smile-o" aria-hidden="true"></i>
                  </a>
                </li> */}
               {/*  <li>
                  <a href="#">GIF</a>
                </li> */}
                {/* <li>
                  <a href="#">
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                  </a>
                </li> */}
               {/*  <li>
                  <a href="#">
                    <i className="fa fa-camera" aria-hidden="true"></i>
                  </a>
                </li> */}
                <li>
                  <a href="#" className="brows_btn">
                    <i className="fa fa-picture-o" aria-hidden="true"></i>
                    <input className="brows_file" type="file" onChange={this.changeFile} multiple accept="image/*,video/*"/>

                  </a>
                </li>
                {/* <li>
                  <a href="#">
                    <i className="fa fa-microphone" aria-hidden="true"></i>
                  </a>
                </li> */}
              </ul>
            </div>
            <div className="modal-footer">
              <input type="submit" className="post_btn" value={languagelist.save}/>
            </div>
          </form>
        </Modal>
      </div>
    );
  }

}

const mapStateToProps = state => {

  return {currentUserDetails: state.login, 
          lastCreatedAlbum  : state.createalbum.newAlbum
         }
}

const mapDispatchToProps = dispatch => {
  return {
    createAlbum: bindActionCreators(createAlbum, dispatch)
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateAlbum));